export default __webpack_public_path__ + "static/media/band-instrument-deals.e0ac3bcf.jpg";